import { render } from "./ClWordRightList.vue?vue&type=template&id=cdd10a46"
import script from "./ClWordRightList.vue?vue&type=script&lang=js"
export * from "./ClWordRightList.vue?vue&type=script&lang=js"

import "./ClWordRightList.vue?vue&type=style&index=0&id=cdd10a46&lang=scss"
import "./ClWordRightList.vue?vue&type=style&index=1&id=cdd10a46&lang=scss"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__